import _ from 'lodash';
import React from 'react';

export const renderHtmlXXX = (text) => <div dangerouslySetInnerHTML={{ __html: text }}></div>

export const cleanHtmlToString = (rawHtml) => {
  // Create a temporary DOM element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = rawHtml;

  // Array of allowed tags to preserve
  const allowedTags = ['strong', 'em', 'u', 'img', 'p'];

  // Function to recursively clean the HTML while keeping allowed tags
  function preserveAllowedTags(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent; // If it's a text node, return the text
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const nodeName = node.nodeName.toLowerCase();

      // If it's an allowed tag, preserve it and its content
      if (allowedTags.includes(nodeName)) {
        if (nodeName === 'img') {
          // For <img>, just preserve the tag (you can also include attributes if needed)
          return `<img src="${node.src}" alt="${node.alt}" width="${node.width}" height="${node.height}">`;
        }

        if (nodeName === 'p') {
          // For <p> tag, preserve it and add a line break after it
          return `<p>${Array.from(node.childNodes).map(preserveAllowedTags).join('')}</p><br>`;
        }

        return `<${nodeName}>${Array.from(node.childNodes).map(preserveAllowedTags).join('')}</${nodeName}>`;
      }
    }

    // For any other tags, just return the text content
    return Array.from(node.childNodes).map(preserveAllowedTags).join('');
  }

  // Get the cleaned content from the temporary div
  const cleanedContent = preserveAllowedTags(tempDiv);

  // Return the cleaned string
  return cleanedContent.trim();
}

export const renderHtml = (text) => {
  return text
    .replace(/<p><br><\/p>/g, '\n')  // Replace <p><br></p> with a single newline
    .replace(/<\/p>/g, '\n')         // Replace </p> with a newline
    .replace(/<p>/g, '')             // Remove opening <p> tags
    .replace(/<br\s*\/?>/gi, '\n');  // Replace <br> or <br/> with a newline
};

export const ammendPTags = (text) => {
  return text
    .replace(/<p><br><\/p>/g, '\n')  // Replace <p><br></p> with a single newline
    .replace(/<\/p>/g, '\n')         // Replace </p> with a newline
    .replace(/<p>/g, '')             // Remove opening <p> tags
    .replace(/<br\s*\/?>/gi, '\n');  // Replace <br> or <br/> with a newline
};

export const ammendTelNumber = (text, returnPrefix = false) => {
  return text.replace(/<a\s+[^>]*href=["']tel:([^"']+)["'][^>]*>.*?<\/a>/gi, '$1');
};

export const ammendGoogleSheetText = (text) => {
  return text.replace(/&nbsp;/g, ' '); // Replace &nbsp; with a space
};

export const parseContent = (htmlString) => {

  const parts = _.split(htmlString, /(<img[^>]+>)/g); // Split into text and images

  return _.map(parts, (part, index) => {
    if (_.startsWith(part, "<img")) {
      // Extract attributes
      const src = _.get(part.match(/src="([^"]+)"/), "[1]", "");
      const alt = _.get(part.match(/alt="([^"]+)"/), "[1]", "");
      const width = _.get(part.match(/width="([^"]+)"/), "[1]", undefined);
      const height = _.get(part.match(/height="([^"]+)"/), "[1]", undefined);
      const styleString = _.get(part.match(/style="([^"]+)"/), "[1]", "");

      return (
        <img
          key={index}
          src={src}
          alt={alt}
          width={width}
          height={height}
          style={parseInlineStyles(styleString)}
        />
      );
    } else {
      return _.trim(part) ? <span key={index}>{_.trim(part)}</span> : null;
    }
  });
};

// Function to parse inline styles into React's camelCase format
const parseInlineStyles = (styleString) => {
  return _.reduce(
    _.split(styleString, ";"),
    (acc, style) => {
      const [key, value] = _.map(_.split(style, ":"), _.trim);
      if (key && value) {
        acc[_.camelCase(key)] = value;
      }
      return acc;
    },
    {}
  );
};

// https://www.bluehost.com/help/article/update-your-credit-card

